const useSound = (url: string): HTMLAudioElement => {
  const audio = new Audio(url)
  audio.volume = 0.4
  return audio
}

export default useSound
